import Task from "./Task";
import { useGetTasksQuery } from "../../features/tasks/tasksApi";
import { useSelector } from "react-redux";

export default function TaskList() {
  const { data: tasks, isLoading, isError } = useGetTasksQuery();
  const { search, filter } = useSelector((state) => state.filter);

  const handleSearch = (task) =>
    task.taskName.toUpperCase().includes(search.toUpperCase());

  const handleFilter = (task) => !filter.includes(task.project.id);

  // decide what to render
  let content = null;
  if (isLoading) content = <h1>Loading</h1>;
  if (!isLoading && isError) content = <h1>There was an error</h1>;
  if (!isLoading && !isError && tasks?.length === 0)
    content = <h1>No Team Member found!</h1>;
  if (!isLoading && !isError && tasks?.length > 0)
    content = tasks
      .filter(handleFilter)
      .filter(handleSearch)
      .map((task) => <Task key={task.id} task={task} />);
  return <>{content}</>;
}
